import React, { useState, useContext } from 'react';
import { useStateContext } from '../contexts/ContextProvider';

import GetAppIcon from '@mui/icons-material/GetApp';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IosShareIcon from '@mui/icons-material/IosShare';

const AddToHome = ({ className }) => {
    const { installPromptEvent } = useStateContext();
    const [openDialog, setOpenDialog] = useState(false);

    const handleDialogOpen = () => {
        setOpenDialog(true);
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
    };

    const installApp = () => {
        if (installPromptEvent) {
            installPromptEvent.prompt();
            installPromptEvent.userChoice.then((choiceResult) => {
                // Optionally handle the choice result here
            });
        }
        handleDialogClose();
    };



    return (
        <div>
            <div className={className} onClick={handleDialogOpen}>
                <GetAppIcon />
                <span>Install app</span>
            </div>
            <Dialog
                open={openDialog}
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Install App"}</DialogTitle>
                <DialogContent>
                    {installPromptEvent
                ? <p>Do you want to add app icon to homescreen?</p>
                : (
                    <>
                        <div>Check if app is already installed or use your browser's 'Add to Home Screen' feature.</div>
                        <br />
                        
                        <p>Iphone - IOS</p>
                        <ol>
                            <li>Tap the  <IosShareIcon /> button.</li>
                            <li>Scroll down</li>
                            <li>Tap Add to Home Screen.</li>
                        </ol>
                        <div>
                        <br />
                        <a href="https://www.androidauthority.com/add-website-android-iphone-home-screen-3181682/#1" 
                                className="link-no-visit-color" 
                                target="_blank" 
                                rel="noopener noreferrer">
                                    General instructions
                                </a>
                        </div>
                            
                       
                    </>
                )
            }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="primary" sx={{
                        margin: '10px', 
                        paddingX:'10px', 
                        borderColor: 'var(--black1)',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        color: 'var(--black1)'
                    }}>
                        Close
                    </Button>
                    {installPromptEvent && (
                        <Button onClick={installApp} autoFocus sx={{
                            margin: '10px', 
                            paddingX:'10px', 
                            borderColor: 'var(--black1)',
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            backgroundColor: 'var(--black1)',
                            color: 'var(--yellow1)'
                        }}>
                            Yes
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default AddToHome;
